import React from "react"
import { Link } from "react-router-dom"
import ScrollParentToTop from "../components/ScrollParentToTop"
const Imprint: React.FC = () => {
	return (
		<>
			<ScrollParentToTop />
			<div className="mx-auto text-blue">
					<div className="bg-blue">
						<div className="max-w-[1324px] mx-auto">
							<h1 className="bg-blue text-white py-24 px-6 md:px-0">Impressum</h1>
						</div>
					</div>
					<div className="mx-auto max-w-[90%] md:max-w-[1324px] text-left">
						<p className=" mb-4">
							Lotus Bakeries GmbH
							<br />
							Roßstraße 92
							<br />
							40476 Düsseldorf
							<br />
						</p><br/>
						<p className=" mb-4">
							0211/440 406-0 <br />
							0211/440 406-99 <br />
							<a href="mailto:info@lotusbakeries.de" className="underline font-bold">
								info@lotusbakeries.de
							</a>
						</p>
						<p className=" mb-4">
							Vertretungsberechtigte: Jana Praß, Els De Smet, Ignace Heyman
							<br />
							Register und Registernummer: HRB 104086, Amtsgericht Düsseldorf
							<br />
							Umsatzsteuer-Identifikationsnummer: DE 811 842 770
							<br />
						</p>
						<p className=" mb-4">
							Nach geltendem Recht sind wir verpflichtet, unsere Kunden auf die Existenz der europäischen Online-Streitbeilegungsplattform hinzuweisen. <a href="https://ec.europa.eu/consumers/odr" className="underline font-bold" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a>
						</p>
						<p className=" mb-4">
							Die Lotus Bakeries GmbH nimmt nicht am Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teil und ist dazu auch nicht verpflichtet.
						</p>
					</div>
					<div className=" py-10 pt-5 text-center text-xl text-blue text-left">
						<Link
							to="/"
							className="btn-primary-yellow"
						>
							Zurück
						</Link>
					</div>
				</div>
					<div className=" bg-blue">
							<div className="max-w-[1324px] mx-auto px-6 pt-4 md:px-0 md:pt-12 pb-12">
								<div className="flex flex-wrap justify-evenly gap-4  max-w-[80%] md:max-w-[60%] mx-auto mt-6 md:mt-0">
									<Link to="/faq" rel="noopener noreferrer" className="text-white text-center font-AmsiRegular text-[22px]">
									FAQ
									</Link>
									<Link to="/teilnahmebedingungen" rel="noopener noreferrer" className="text-white text-center font-AmsiRegular text-[22px]">
									Teilnahmebedingungen
									</Link>
									<a href="https://www.trekbars.com/de/datenschutzbestimmungen" target="_blank" rel="noopener noreferrer" className="text-white text-center font-AmsiRegular text-[22px]">
									Datenschutz
									</a>
									<Link to="/kontakt"  rel="noopener noreferrer" className="text-white text-center font-AmsiRegular text-[22px]">
									Kontakt
									</Link>
									<Link to="/impressum"  rel="noopener noreferrer" className="text-white text-center font-AmsiRegular text-[22px]">
									Impressum
									</Link>
									</div>
							</div>
						</div>
		</>
	)
}
export default Imprint
